<!--
 * @Author: lishiqiao
 * @Date: 2022-03-10 11:13:34
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-10 11:29:19
-->
<template>
  <div class="page-list">
    <!-- 汇总表-养成 -->
    <SummaryPage v-if="pageType === 'summary'" @getPageType="getPageType" />
    <!-- 明细表-养成 -->
    <DetailPage v-if="pageType === 'detail'" @getPageType="getPageType" />
  </div>
</template>

<script>
import SummaryPage from "./yc-sales-volume-summary.vue";
import DetailPage from "./yc-sales-volume-detail.vue";
export default {
  name: "yc-sales-volume",
  data() {
    return {
      pageType: "summary", // summary汇总表,detail明细表
    };
  },
  computed: {},
  methods: {
    getPageType(pageType) {
      this.pageType = pageType;
    },
  },
  components: {
    SummaryPage,
    DetailPage,
  },
};
</script>

<style lang="less" scoped>
</style>